import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

Vue.use(Router);

// Узкий кабинет KZ-контура (PROC-4295): из 64 маршрутов общего бэкофиса оставлены шесть —
// вход, транзакции со списком и карточкой, мерчанты с карточкой мерчанта и карточкой счёта.
// Остальные разделы не спрятаны настройкой, а отсутствуют: их экраны удалены из сборки.
// Пути оставлены прежними (`/users`, `/account/accountInfo/:id`), чтобы не переписывать
// ссылки внутри перенесённых экранов; в интерфейсе раздел называется «Мерчанты».

function logPrevious (to, from, next) {
    localStorage.setItem("previousPath", from.path);
    next();
}

function isAuthenticated() {
    return localStorage.getItem('token') !== null || localStorage.getItem('authProvider') === 'okta';
}

function requireAuth (to, from, next) {
    if (isAuthenticated() && store.getters.isLoggedIn) {
        next();
    } else {
        next('/');
    }
}

// PROC-4295: вход ведёт сразу в транзакции. В общем бэкофисе здесь был `/users`.
function checkLogged (to, from, next) {
    if (isAuthenticated() && store.getters.isLoggedIn) {
        next('/transactions');
    } else {
        next('/');
    }
}

function loginAvailable (to, from, next) {
    if (isAuthenticated() && store.getters.isLoggedIn) {
        next('/transactions');
    } else {
        next();
    }
}

export default new Router({
    routes: [
        {
            path: '/payments',
            beforeEnter: requireAuth,
            component: () => import(/* webpackChunkName: "merchant" */ './views/mainlayout'),
            children: [
                {
                    path: '/transactions',
                    name: 'Транзакции',
                    meta: {
                        title: 'Транзакции'
                    },
                    beforeEnter: logPrevious,
                    component: () => import(/* webpackChunkName: "trans" */ './views/transactions/Transactions')
                },
                {
                    path: '/transactions/info/:id/',
                    name: 'Информация о транзакции',
                    meta: {
                        title: 'Информация о транзакции'
                    },
                    component: () => import('./views/transactions/Transactions_info')
                },
                {
                    // Без `name`: это обёртка-лейаут, а её дочерний маршрут имеет тот же путь
                    // `/users`. Одинаковые имена на обоих дают vue-router
                    // "Duplicate named routes definition" и ломают переходы по имени.
                    path: '/users',
                    meta: {
                        title: 'Мерчанты'
                    },
                    component: () => import(/* webpackChunkName: "users" */ './views/users/Userlayout'),
                    children: [
                        {
                            path: '/users',
                            name: 'Мерчанты',
                            meta: {
                                title: 'Мерчанты'
                            },
                            component: () => import(/* webpackChunkName: "users" */ './views/users/Users')
                        },
                        {
                            path: '/users/userpage/:id/:merchantKey',
                            name: 'Мерчант',
                            meta: {
                                title: 'Мерчант'
                            },
                            component: () => import('./views/userpage/Userpage')
                        },
                        {
                            path: '/account/accountInfo/:id',
                            name: 'Счет',
                            meta: {
                                title: 'Счет'
                            },
                            component: () => import('./views/accouts/accountInfo')
                        }
                    ]
                }
            ]
        },
        {
            path: '/',
            beforeEnter: loginAvailable,
            name: 'Login',
            component: () => import(/* webpackChunkName: "login" */ './views/login/Login.vue')
        },
        {
            path: '*',
            beforeEnter: checkLogged,
            meta: {
                title: 'Мерчант'
            }
        }
    ]
})
